<template>
  <div>
    <div
      class="container-top mt-5"
      :class="{ 'container-medium': lgAndUp || xlAndUp }"
    >
      <div class="row d-md-flex justify-content-between mb-5">
        <div class="col-md-12">
          <div class="text-head h2  font-weight-bold">
            Attendance Category
          </div>
          <div @click="goBack">
            <span class="s-18 fw-400 cursor-pointer text-black">
              <img src="../../assets/gobacck.png" class="w-12 h-12" alt="" /> Go
              back</span
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div
            class="border-radius-8 bg-gray-200 pb-3 pt-3 px-3 mt-5 row justify-content-center"
          >
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="mt-2 text-dak fw-500 mb-2">
                    Add New Attendance Category
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="row d-md-flex">
                    <div class="col-md-12">
                      <el-input
                        type="text"
                        class="w-100"
                        placeholder="Attendance category name"
                        v-model="attendanceName"
                        size="large"
                      />
                    </div>
                    <div class="col-md-12 d-flex justify-content-end">
                      <div class="col-md-2 mt-3">
                        <el-button
                          size="large"
                          :color="primarycolor"
                          round
                          @click="saveAttendant"
                          :loading="loading"
                        >
                          Save category
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div
              class="col-md-12 border-radius-8 mt-4"
              style="border: 1px solid #aaaaaa"
            >
              <div class="row table-header-row">
                <div class="col-md-12 py-3">
                  <div class="col-md-7">
                    <span class="py-2 text-dak fw-500">Category</span>
                  </div>
                </div>
                <!-- <div class="col-md-5 text-center">
              <span class="py-2 font-weight-bold mr-md-5 mr-0">ACTION</span>
            </div> -->
              </div>

              <div class="row py-1" v-for="(type, index) in types" :key="index">
                <div class="col-md-12">
                  <div class="row pl-3">
                    <div
                      class="col-md-7 px-0 d-flex justify-content-between align-items-center mb-md-0 mb-5"
                    >
                      <span class="py-2 hidden-header">Name</span>
                      <span class="py-2 font-weight-bold text-dak text-xs-left mr-md-0 ml-md-3 mr-4">{{
                        type.name
                      }}</span>
                    </div>
                    <div
                      class="col-md-5 pl-3 mb-md-0 mb-2 col-12 d-flex justify-content-end align-items-end"
                    >
                      <!-- <span class="py-md-4 hidden-header hidden-header1"
                        >ACTION</span
                      > -->
                      <div class="row py-2" v-if="vissibleTab !== `tab_${index}`">
                        <div
                          class="col-md-6 col-6 d-flex justify-content-center"
                        >
                          <el-button
                            class="py-1 px-4"
                            style="background-color: #b4f1f4"
                            @click="openType(index)"
                            size="large"
                            round
                            color="#EBEFF4"
                          >
                            <span
                              style="color: #030303 !important"
                              class="fw-400 s-16"
                              >Edit</span
                            >
                          </el-button>
                        </div>
                        <div
                          class="col-md-6 col-6 d-flex justify-content-start"
                        >
                          <el-button
                            class="py-1 delete-btn text-white"
                            @click="deletePop(type.id)"
                            size="large"
                            round
                          >
                            <span class="s-16 fw-400">Delete</span>
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="row bg-gray-200 py-1 border-radius-8 ml-0 mr-2 mt-2"
                    v-if="vissibleTab === `tab_${index}`"
                  >
                    <div
                      class="col-md-7 d-flex justify-content-between align-items-center mb-md-0 mb-2"
                    >
                      <label for="" class="d-flex mt-4">
                        <!-- <span class="mr-2">Name</span> -->
                        <el-input
                          type="text"
                          class="w-100"
                          v-model="typeName"
                        />
                      </label>
                    </div>
                    <div
                      class="col-md-5 d-flex justify-content-end align-items-center mt-0"
                    >
                      <div class="row">
                        <div class="col-md-6 col-6 d-flex justify-content-end">
                          <el-button
                            class="secondary-button px-3"
                            @click="discard"
                            color="#F6F6F6"
                            round
                          >
                            Discard
                          </el-button>
                        </div>
                        <div
                          class="col-md-6 col-6 d-flex justify-content-start"
                        >
                          <el-button
                            class="text-white px-4 ml-md-0 ml-5"
                            @click="updateAttendant(type.id, index)"
                            round
                            color="#0B55D4"
                          >
                            Save
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 px-0">
                      <hr class="hr my-0" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center p-5" v-if="loading">
                <i
                  class="pi pi-spin pi-spinner text-center text-primary"
                  style="font-size: 3rem"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/gateway/backendapi";
import { ElMessage, ElMessageBox } from "element-plus";
import finish from "../../services/progressbar/progress";
import router from "../../router";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";

export default {
  components: {},
  inject: ["primarycolor"],
  data() {
    return {
      types: [],
      vissibleTab: "",
      typeName: "",
      attendanceName: "",
      ageGroup: "",
      loading: false,
    };
  },
  setup() {
    const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
    return {
      mdAndUp,
      lgAndUp,
      xlAndUp,
      xsOnly,
    };
  },

  methods: {
    goBack() {
      router.go(-1);
    },
    async getTypes() {
      try {
        this.loading = true;
        const { data } = await axios.get(
          "/api/Settings/TenantAttentandaceTypes"
        );
        this.types = data;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    deletePop(id) {
      ElMessageBox.confirm(
        "Are you sure you want to Delete?",
        "Confirm delete",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "error",
        }
      )
        .then(() => {
          this.deleteAttendant(id);
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "Delete canceled",
            duration: 5000,
          });
        });
    },

    async deleteAttendant(id) {
      try {
        await axios.delete("/api/Settings/DeleteAttendanceType/" + id);
        this.types = this.types.filter((i) => i.id !== id);
        ElMessage({
          type: "success",
          message: "Attendance Deleted Successfully",
          duration: 5000,
        });
      } catch (error) {
        finish();
        console.log(error);
      }
    },
    async updateAttendant(id, index) {
      try {
        await axios.put("/api/Settings/UpdateAttendanceType", {
          attendanceTypeName: this.typeName,
          attendanceTypeId: id,
        });
        this.types[index].name = this.typeName;
        this.discard();
        ElMessage({
          type: "success",
          message: "Attendance Updated Successfully",
          duration: 5000,
        });
      } catch (error) {
        finish();
        console.log(error);
      }
    },
    async saveAttendant() {
      try {
        await axios.post(
          "/api/Settings/NewAttendanceType/" + this.attendanceName
        );
        this.getTypes();
        this.attendanceName = "";
        ElMessage({
          type: "success",
          message: "Attendance Save Successfully",
          duration: 5000,
        });
      } catch (error) {
        finish();
        console.log(error);
      }
    },
    openType(index) {
      this.vissibleTab = `tab_${index}`;
      this.typeName = this.types[index].name;
    },

    discard() {
      this.vissibleTab = "";
    },
    del(index) {
      this.types.splice(index, 1);
    },
  },

  created() {
    this.getTypes();
  },
};
</script>

<style scoped>
input::placeholder {
  text-align: center;
}

.table-header-row {
  background: #f6f6f6;
  border-radius: 8px;
}

.hidden-header {
  display: none;
}

.grey-background {
  background: #dde2e6;
}
.delete-btn {
  background: #ff3737 !important;
}
.delete-btn:hover {
  background-color: red !important;
  color: white !important;
}

.save-btn {
  background: #50ab00;
}
.delbtn:hover {
  background-color: red !important;
  color: white !important;
}
.delbtn {
  background-color: #f2bc9e !important;
  color: black !important;
}
.delbtn:focus {
  outline: none !important;
  border: none !important;
}
.attend {
  font: var(--unnamed-font-style-normal) normal 800 34px/46px
    var(--unnamed-font-family-nunito-sans);
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  font: normal normal 800 34px/46px Nunito Sans;
  letter-spacing: 0px;
  color: #02172e;
  opacity: 1;
}
.attend1 {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    24px/32px var(--unnamed-font-family-nunito-sans);
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  font: normal normal bold 24px/32px Nunito Sans;
  letter-spacing: 0px;
  color: #02172e;
  opacity: 1;
}

@media screen and (max-width: 767px) {
  .hidden-header1 {
    display: none !important;
  }
  .hidden-header {
    display: inline-block;
    font-weight: bold;
  }

  .table-header-row {
    display: none;
  }
}
@media screen and (max-width: 390px) {
  .attend {
    font: var(--unnamed-font-style-normal) normal 500 20px/25px
      var(--unnamed-font-family-nunito-sans);
    letter-spacing: var(--unnamed-character-spacing-0);
    text-align: left;
    font: normal normal 800 20px/25px Nunito Sans;
    letter-spacing: 0px;
    color: #02172e;
    opacity: 1;
  }
  .attend1 {
    font: var(--unnamed-font-style-normal) normal
      var(--unnamed-font-weight-bold) 24px/32px
      var(--unnamed-font-family-nunito-sans);
    letter-spacing: var(--unnamed-character-spacing-0);
    text-align: left;
    font: normal normal bold 18px/20px Nunito Sans;
    letter-spacing: 0px;
    color: #02172e;
    opacity: 1;
  }
}
</style>
